import { Component } from 'react'
import moment from 'moment'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import { DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE, YESTERDAY } from '../../../../../constants/date'
import { getUIFormatDate } from '../../../../../lib/MomentHelper'
import DateHelper from '../../../../../lib/DateHelper'
import { RangePickerField, CheckboxGroupField } from '../../../../Common/Form'
import FormRow from '../../../../Common/NewDashboard/FormRow/FormRow'
import {
  formDecorator,
  Field
} from '../../../../Common/forms'
import styles from './SearchForm.css'

const FIELD = {
  TYPE: 'type',
  REPORT_DATE: 'reportDate'
}

const TYPE = {
  ALL_MEM: '101',
  NEW_MEM: '102',
  RET_MEM: '103'
}

const TYPE_MAP = {
  [TYPE.ALL_MEM]: '會員數',
  [TYPE.NEW_MEM]: '新客數',
  [TYPE.RET_MEM]: '回客數'
}

const TYPE_FULL_OPTIONS = [
  {
    label: TYPE_MAP[TYPE.ALL_MEM],
    value: TYPE.ALL_MEM
  },
  {
    label: TYPE_MAP[TYPE.NEW_MEM],
    value: TYPE.NEW_MEM
  },
  {
    label: TYPE_MAP[TYPE.RET_MEM],
    value: TYPE.RET_MEM
  }
]

export const CONFIG = {
  form: 'MEM_ANA_FORM',
  initialValues: {
    [FIELD.REPORT_DATE]: DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE,
    [FIELD.TYPE]: [TYPE_FULL_OPTIONS[0].value, TYPE_FULL_OPTIONS[1].value, TYPE_FULL_OPTIONS[2].value]
  }
}

class SearchForm extends Component {
  constructor (props) {
    super(props)
    /*
      資料查詢區塊
      僅接30天內之資料查詢
      起：兩年以前之日期不可選擇
      迄且現在是 12:00:00 以後：今天(含)以後之日期不可選擇
      迄且現在是 11:59:59 以前：前一天(含)以後之日期不可選擇
    */
    const {
      startMinDate
    } = DateHelper.getSaleStatDefaultPeriod()
    const [start, end] = DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE
    this.state = {
      periodStartMinDate: startMinDate,
      periodEndMaxDate: YESTERDAY,
      periodStart: getUIFormatDate(start),
      periodEnd: getUIFormatDate(end)
    }
  }

  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
  }

  // 調整「起」的日期後，則「迄」跟著自動變動：
  // 「起」＋ㄧ個月 (30 天) ; 之後的日期 disable 不可選
  // 若「起」＋ㄧ個月 (30 天)  > 昨日，則為昨日
  disabledDate = dateMoment => {
    const {
      periodEndMaxDate,
      periodStartMinDate,
      periodStart
    } = this.state
    const oneMonthsLaterData = moment(periodStart).add(30, 'days')
    const todayData = moment()
    return dateMoment < moment(periodStartMinDate) ||
    dateMoment >= (moment(oneMonthsLaterData).isBefore(todayData) ? oneMonthsLaterData : periodEndMaxDate)
  }

  onCalendarChange = dateMoment => {
    const periodStart = dateMoment[0].format('YYYY/MM/DD')
    this.setState({
      periodStart
    })
  }

  onMainRangeChange = (dateMoment, dateString) => {
    const [periodStart, periodEnd] = dateString
    this.setState({
      periodStart,
      periodEnd
    })
  }

  render () {
    const { customRange, tip } = this.props
    return (
      <form
        onSubmit={this.onSubmit}
        className={styles.searchForm}
      >
        <FormRow
          label='日期區間'
          labelAlign='center'
        >
          <Field
            key={FIELD.REPORT_DATE}
            name={FIELD.REPORT_DATE}
            data-role={FIELD.REPORT_DATE}
            className={styles.rangePicker}
            component={RangePickerField}
            defaultValue={customRange}
            onChange={this.onMainRangeChange}
            disabledDate={this.disabledDate}
            onCalendarChange={this.onCalendarChange}
          />
        </FormRow>
        <FormRow
          label={TYPE_MAP[TYPE.ALL]}
        >
          <Field
            key={FIELD.TYPE}
            name={FIELD.TYPE}
            data-role={FIELD.TYPE}
            component={CheckboxGroupField}
            options={TYPE_FULL_OPTIONS}
          />
        </FormRow>
        <FormRow
          labelAlign='top'
          className={styles.tips}
        >
          <Tip type='info'>
            {
              tip ||
              '可查詢最早日期為兩年前，起迄區間最長為30天，每日中午更新'}
          </Tip>
        </FormRow>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(SearchForm)

export default SearchFormWithDecorator
